export default {
    buttons: {
        add_location: 'Add location',
    },
    fields: {
        name: {
            label: 'Service name',
            placeholder: 'Enter the service name',
        },
        company: {
            label: 'Company (optional)',
            placeholder: 'Select',
        },
        location: {
            label: 'Service Location',
            placeholder: 'Select',
        },
        description: {
            label: 'Description',
            placeholder: 'Describe your service...',
        },

        appointment_length: {
            label: 'Appointment length',
            placeholder: 'Select',
        },
        price: {
            label: 'Price',
            placeholder: 'Enter',
        },
        currency: {
            label: 'Currency',
            placeholder: 'EUR/RDS',
        },
        category: {
            label: 'Category',
            placeholder: 'Select',
        },
        subcategory: {
            label: 'Sub category',
            placeholder: 'Select',
        },
        default_calendar_event_status: {
            label: 'Do you want to automatically accept reservations on this service?',
        },
        public_reservation: {
            label: 'Block public reservation?',
        },
        reservation_in_advance: {
            label: 'Allow reservations in advance',
            placeholder: 'Select',
            tooltip:
                "How far in advance do you allow clients to book an appointment? For example, 60 minutes means the client won't be able to book an appointment starting in less than an hour.",
        },
        cancellation_in_advance: {
            label: 'Allow cancellation in advance',
            placeholder: 'Select',
            tooltip:
                "How far in advance do you allow clients to cancel an appointment? For example, 60 minutes means the client won't be able to cancel an appointment starting in less than an hour.",
        },
        rescheduling_in_advance: {
            label: 'Allow rescheduling in advance',
            placeholder: 'Select',
            tooltip:
                "How far in advance do you allow clients to reschedule an appointment? For example, 60 minutes means the client won't be able to reschedule an appointment starting in less than an hour.",
        },
        pause: {
            label: 'Pause duration (Min)',
            placeholder: 'Enter',
            tooltip:
                'Enter the desired duration for your break or inactivity (in minutes). Your calendar time will be divided into intervals of the specified number of minutes. The minimum duration is 15 minutes, and the maximum is 180 minutes.',
        },
        reservation_type: {
            label: 'Reservation Type',
            placeholder: 'Select',
            tooltip:
                'Approval - you manually accept bookings; Automatic - bookings are accepted automatically; Blocking - only you can create bookings for yourself; Regos - technical inspections.',
        },
    },
    reservation_type: {
        request_approval: 'Approval of reservations',
        accepted_by_default: 'Automatically accepted reservations',
        block_public_reservations: 'Blocking public reservations',
        external_system_regos: 'Regos - external system',
        request_service: 'Reservation request',
    },

    header: 'Enter category',
    table: {
        title: 'Title',
        price: 'Price',
        length: 'Duration',
        description: 'Description',
        actions: 'Actions',
    },
    errors: {
        location: {
            company_has_no_locations: 'This company has 0 locations',
        },
        category: {
            warning: 'In order for your service to be visible, you need to add at least one category!',
        },
    },
}
